<template>
  <div id="app">
    <vue-extend-layouts loading="loading" />
  </div>
</template>

<script>
import VueExtendLayouts from 'vue-extend-layout'

export default {
  name: 'App',
  components: { VueExtendLayouts }
}
</script>



// WEBPACK FOOTER //
// src/App.vue